var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "status" }, [
    _vm.object.status == 0
      ? _c("i", {
          staticClass: "fa fa-circle-o fa-2x fa-fw",
          class: "status-" + _vm.object.status + "c",
          attrs: { title: _vm.$t("device.registrations.cols.state.0") },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.object.status == 1
      ? _c("i", {
          staticClass: "fa fa-clock-o fa-2x fa-fw",
          class: "status-" + _vm.object.status + "c",
          attrs: { title: _vm.$t("device.registrations.cols.state.1") },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.object.status == 2
      ? _c(
          "span",
          {
            staticClass: "fa-stack fa-fw",
            attrs: { title: _vm.$t("device.registrations.cols.state.2") },
          },
          [
            _c("i", { staticClass: "fa fa-circle-o fa-stack-2x" }),
            _c("i", {
              staticClass: "fa fa-mobile-phone fa-stack-1x",
              class: "status-" + _vm.object.status + "c",
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.object.status == 3
      ? _c("i", {
          staticClass: "fa fa-times-circle-o fa-2x fa-fw",
          class: "status-" + _vm.object.status + "c",
          attrs: { title: _vm.$t("device.registrations.cols.state.3") },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }